import actions from './actions'
import getters from './getters'
import mutations from './mutations'

/** Os dois estados nascem vazios para a faixa decidir se aparece antes da primeira resposta. */
const emptyPanel = () => ({
  total: 0,
  truncated: false,
  can_review: false,
  operations: [],
})

const state = {
  unread: emptyPanel(),
  // `loaded` evita rebuscar o histórico a cada troca do alternador: ele só é carregado quando o
  // usuário pede "Todos" pela primeira vez, e invalidado quando um lote muda de lado.
  recent: { ...emptyPanel(), loaded: false },
  acknowledgeModal: {
    reference: undefined,
    visible: false,
    saveAction: () => {},
  },
}

export default {
  state,
  actions,
  getters,
  mutations,
}
